import { render, staticRenderFns } from "./summaryGroup.vue?vue&type=template&id=5d960bd8"
import script from "./summaryGroup.vue?vue&type=script&lang=js"
export * from "./summaryGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports